import essential from './essential';
import dummy from './dummy';
import productBulkEdit from './product-bulk-edit';
import salesperson from './salesperson';
import shipping from './shipping';
import promotions from './promotions';

import type { Addon } from './types';

const ALL: Array<{ i: number; module: Addon }> = [
  { i: 0, module: essential },
  { i: 1, module: salesperson },
  { i: 2, module: productBulkEdit },
  { i: 3, module: shipping },
  { i: 5, module: promotions },
  { i: 999, module: dummy },
];

const addons: Addon[] = ALL.sort((a, b) => a.i - b.i).map((i) => i.module);

const enabledAddons: Addon[] = [];
addons.forEach((addon) => {
  const subscription = window.subscriptions[addon.info.id];
  if (!subscription) {
    addon.enabled = false;
    return;
  }

  addon.enabled = true;
  addon.expired = subscription.expired;
  addon.billingCycle = subscription.billingCycle;
  addon.unsubscribed = subscription.unsubscribed;
  addon.expiredAt = subscription.expiredAt;

  if (!addon.expired) {
    enabledAddons.push(addon);
  }
});

export {
  addons,
  enabledAddons,
};
